import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Concatène des classes conditionnelles (clsx) puis résout les conflits Tailwind
 * (tailwind-merge) : la dernière classe d'un même groupe gagne.
 *
 *   cn("px-4 bg-accent", isDanger && "bg-danger-500")  →  "px-4 bg-danger-500"
 *
 * Sans ce merge, `className` passé par un consommateur ne pourrait pas surcharger
 * le style par défaut d'un composant — les deux classes coexisteraient et c'est
 * l'ordre dans le CSS compilé qui trancherait, de façon imprévisible.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
